import React from 'react';
import { MainHeadline } from './MainHeadline';
import { DoctorStory } from './DoctorStory';
import { IndustrySecret } from './IndustrySecret';
import { NightlyDamage } from './NightlyDamage';
import { ClinicalEvidence } from './ClinicalEvidence';
import { SilkBenefits } from './SilkBenefits';
import { Testimonials } from './Testimonials';
import { PricingSection } from './PricingSection';
import { CallToAction } from './CallToAction';
export const AdvertorialContent = () => {
  return <main className="flex-grow w-full bg-white" data-id="element-5">
      <div className="container mx-auto px-4 py-8 max-w-4xl" data-id="element-6">
        <MainHeadline data-id="element-7" />
        <DoctorStory data-id="element-8" />
        <IndustrySecret data-id="element-9" />
        <NightlyDamage data-id="element-10" />
        <ClinicalEvidence data-id="element-11" />
        <SilkBenefits data-id="element-12" />
        <Testimonials data-id="element-13" />
        <PricingSection data-id="element-14" />
        <CallToAction data-id="element-15" />
      </div>
    </main>;
};